enum Routes {
  Main = '/',
  Calendar = '/calendar',
  List = '/list'
}

export default Routes;
